<div class="bg-gradient-to-r from-blue-400 via-blue-500 to-purple-600 text-white rounded-md mx-6 mt-4 shadow-lg overflow-hidden transition-all duration-500 px-2"
     [class.pb-4]="showFilters">

  <div class="flex justify-between items-center p-4">
    <div>
      <h2 class="text-2xl font-bold">Operator Performance Dashboard</h2>
      <div class="flex items-center space-x-4 mt-1 text-sm">
        <span class="flex items-center space-x-1">
          <i class="far fa-calendar-alt"></i>
          <span>{{ months[selectedMonth] }} {{ selectedYear }} - OffSet Department</span>
        </span>
        <span class="flex items-center space-x-1">
          <i class="far fa-clock"></i>
          <span>{{ currentTime }}</span>
        </span>
      </div>
    </div>

    <div class="flex items-center gap-6">
      <div class="text-right">
        <p class="font-bold">Live Dashboard</p>
        <p class="text-xs">Auto-refresh every 30 minutes</p>
      </div>

      <button 
        class="p-2 rounded-full bg-white/20 hover:bg-white/30 transition"
        (click)="showFilters = !showFilters">
        <svg xmlns="http://www.w3.org/2000/svg" 
             fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" 
             class="w-6 h-6 text-white">
          <path stroke-linecap="round" stroke-linejoin="round" 
                d="M3 4h18M6 12h12M10 20h4"/>
        </svg>
      </button>
    </div>
  </div>

  <div *ngIf="showFilters" class="px-4 pb-2">
    <div class="flex flex-wrap justify-center items-center gap-4">
      <select id="department" [(ngModel)]="departmentId" 
              class="px-3 py-2 rounded-md bg-white/10 border border-white/20 text-gray-900 text-sm focus:outline-none focus:ring-2 focus:ring-white/40"
              (ngModelChange)="onDepartmentChange($event)">
        <option value="null" hidden disabled selected>Choose a Department</option>
        @for (dept of $$departmentDTO(); track dept.departmentId) {
          <option [value]="dept.departmentId">{{ dept.departmentName | titlecase }}</option>
        }
      </select>

      <select id="machine" class="px-3 py-2 rounded-md bg-white/10 border border-white/20 text-gray-900 text-sm focus:outline-none focus:ring-2 focus:ring-white/40"
              [(ngModel)]="machineId" (ngModelChange)="onMachineChange($event)">
        <option value="null" hidden disabled selected>Choose a Machine</option>
        @for (machine of $$availableMachines(); track machine) {
          <option [value]="machine.machineId">{{ machine.machineName | titlecase }}</option>
        }
      </select>

      <select class="px-3 py-2 rounded-md bg-white/10 border border-white/20 text-gray-900 text-sm focus:outline-none focus:ring-2 focus:ring-white/40"
              [(ngModel)]="selectedYear" (change)="updateCalendarYear(selectedYear)">
        @for (year of years; track year) {
          <option [value]="year">{{ year }}</option>
        }
      </select>

      <select class="px-3 py-2 rounded-md bg-white/10 border border-white/20 text-gray-900 text-sm focus:outline-none focus:ring-2 focus:ring-white/40"
              [(ngModel)]="selectedMonth" (change)="updateCalendarMonth(selectedMonth)">
        @for (month of months; track $index) {
          <option [value]="$index">{{ month }}</option>
        }
      </select>
    </div>
  </div>
</div>

<div class="space-y-4 pt-2 px-4 pb-4">
  @for (op of $$machineMonthlyOutputDTO()[0].data; track op.operatorId) {
    <div class="bg-white rounded-lg mx-2 mt-2 py-6 shadow-sm border-l-4 border-blue-500">
      
      <div class="flex gap-6 px-8 items-center ">

        <!-- Left: Profile (fixed narrow width) -->
        <div class="flex flex-col items-center text-center w-32 shrink-0">
          <div class="w-12 h-12 flex items-center justify-center rounded-full text-white font-bold text-lg bg-indigo-600">
            {{ op.operatorName[0] }}
          </div>
          <p class="mt-2 font-semibold text-gray-900 truncate w-full">{{ op.operatorName }}</p>
          <p class="text-xs text-gray-600 flex items-center gap-1">
            <span class="w-2 h-2 rounded-full bg-green-500 inline-block"></span>
            Active
          </p>
        </div>

        <!-- Weekly Performance -->
        <div class="flex-[1.5] min-w-[300px]">
           <h4 class="flex items-center gap-2 text-base font-bold text-gray-700 pb-4">
            <svg xmlns="http://www.w3.org/2000/svg" 
                fill="none" viewBox="0 0 24 24" stroke-width="3" stroke="currentColor" 
                class="w-4 h-4 text-black-600">
              <path stroke-linecap="round" stroke-linejoin="round" 
                    d="M3 3v18h18M19 9l-6 6-4-4-6 6"/>
            </svg>
            Weekly Performance
          </h4>
          <div class="mt-2 space-y-1" *ngFor="let week of weekKeys; let i = index">
            <div class="flex items-center space-x-2">
              <span class="w-16 text-xs font-semibold text-gray-600">Week {{ i+1 }}</span>
              <div class="flex-1 bg-gray-200 rounded-full h-2">
                <div class="h-3 rounded-full"
                     [ngClass]="['bg-blue-600','bg-green-500','bg-orange-400','bg-red-500'][i]"
                     [style.width]="getAnimatedWidth($any(op)[week])">
                </div>
              </div>
              <span class="w-12 text-sm font-bold text-gray-600 text-right">
                {{ $any(op)[week] | number }}
              </span>
            </div>
          </div>
        </div>

        <!-- Production -->
        <div class="flex-1 px-8">
          <h4 class="flex gap-2 text-base font-bold text-gray-700">
            <svg xmlns="http://www.w3.org/2000/svg" 
                fill="none" viewBox="0 0 24 24" 
                stroke-width="3" stroke="currentColor" 
                class="w-5 h-5 text-black-600">
              <path stroke-linecap="round" stroke-linejoin="round" 
                    d="M3 21V9l6 3V9l6 3V9l6 3v9H3z" />
            </svg>
            Production
          </h4>

          <div class="mt-6 flex flex-row gap-16">
            <div>
              <p class="text-2xl font-bold text-indigo-700">{{ op.total_output | number}}</p>
              <p class="text-sm text-gray-500">Monthly Output</p>
            </div>
            <div>
              <p class="text-pink-600 mt-2 font-semibold">{{ op.total_output/op.actualHours | number:'1.0-0' }}</p>
              <p class="text-sm text-gray-500">Average output for an hour</p>
            </div>
            <!-- <div>
              <p class="text-pink-600 mt-2 font-semibold">- Makerady Count</p>
              <p class="text-xs text-gray-500">In this month.</p>
            </div> -->
          </div>
        </div>


        <!-- Hours & Quality -->
       <div class="flex-1">
        <h4 class="flex items-center gap-2 text-base font-semibold text-gray-700">
          <svg xmlns="http://www.w3.org/2000/svg" 
              fill="none" viewBox="0 0 24 24" stroke-width="3" stroke="currentColor" 
              class="w-5 h-5 text-gray-700">
            <path stroke-linecap="round" stroke-linejoin="round" 
                  d="M12 6v6l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          Hours & Quality
        </h4>
        <div class="mt-6 text-sm space-y-2 px-2">
          <p>Monthly Worked Hours - <span class="font-bold text-blue-600">{{ Math.round(op.actualHours) }}</span></p>
          <p>Monthly NCR Count - <span class="font-bold text-orange-500">Not set</span></p>
        </div>
      </div>


        <!-- Targets -->
      <div class="flex-1">
        <h4 class="flex items-center gap-2 text-base font-semibold text-gray-700">
          <svg xmlns="http://www.w3.org/2000/svg" 
              fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" 
              class="w-5 h-5 text-gray-700">
            <circle cx="12" cy="12" r="9" stroke="currentColor" />
            <circle cx="12" cy="12" r="5" stroke="currentColor" />
            <circle cx="12" cy="12" r="2" fill="currentColor" />
          </svg>
          Targets Completion
        </h4>

        <div class="flex gap-8 mt-6 px-4">

          <div class="text-red-600">Not yet calculated!</div>
          
          <!-- <div class="flex flex-col items-center">
            <span class="text-sm font-medium text-gray-700 mb-2">Weekly</span>
            <div class="relative w-20 h-20">
              <svg viewBox="0 0 36 36" class="w-20 h-20">
                <path class="text-gray-200" stroke-width="3.8" stroke="currentColor" fill="none"
                  d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"/>
                <path class="text-teal-500" stroke-width="3.8" stroke-dasharray="70, 100" stroke-linecap="round"
                  stroke="currentColor" fill="none"
                  d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"/>
              </svg>
            </div>
            <span class="mt-2 text-sm font-semibold text-teal-600">70%</span>
          </div> -->

          <!-- <div class="flex flex-col items-center">
            <span class="text-sm font-medium text-gray-700 mb-2">Monthly</span>
            <div class="relative w-20 h-20">
              <svg viewBox="0 0 36 36" class="w-20 h-20">
                <path class="text-gray-200" stroke-width="3.8" stroke="currentColor" fill="none"
                  d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"/>
                <path class="text-pink-500" stroke-width="3.8" stroke-dasharray="60, 100" stroke-linecap="round"
                  stroke="currentColor" fill="none"
                  d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"/>
              </svg>
            </div>
            <span class="mt-2 text-sm font-semibold text-pink-600">60%</span>
          </div> -->
        </div>
      </div>

      </div>

    </div>
  }
</div>


